<template>
  <main>
    <tab-header />
    <div class="tab-content" v-show="rolePermission">
      <div class="tab-pane active show">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="radio radio-inline">
                        <input type="radio" v-model="searchType" id="search-type-1" value="1">
                        <label for="search-type-1">強制調撥總表</label>
                    </div>
                    <div class="radio radio-inline">
                        <input type="radio" v-model="searchType" id="search-type-2" value="2">
                        <label for="search-type-2">離退職人員撥出</label>
                    </div>
                    <div class="radio radio-inline">
                        <input type="radio" v-model="searchType" id="search-type-3" value="3">
                        <label for="search-type-3">2年內新人&AFP/CFP撥入</label> 
                    </div>
                    <div class="radio radio-inline">
                        <input type="radio" v-model="searchType" id="search-type-4" value="4">
                        <label for="search-type-4">全單位未訪件(已無使用)</label>
                    </div>
                </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-12">
                  <form class="form">
                    <div class="form-group row">
                        <label class="col-1 text-right">應撥月份</label>
                        <div class="col-5">
                            <select v-if = "this.form.allyear" class="form-control form-control-inline" v-model="form.startYear" disabled>
                              <option
                              v-for="(year, yearIndex) in yearOpt"
                              :key="`service-year-${yearIndex}`"
                              :value="year.value">{{year.text}}</option>
                            </select>
                            <select v-else class="form-control form-control-inline" v-model="form.startYear" >
                              <option
                              v-for="(year, yearIndex) in yearOpt"
                              :key="`service-year-${yearIndex}`"
                              :value="year.value">{{year.text}}</option>
                            </select>
                            <select v-if = "this.form.allyear" class="form-control form-control-inline" v-model="form.startMonth" disabled>
                              <option
                              v-for="(month, monthIndex) in monthOpt"
                              :key="`service-month-${monthIndex}`"
                              :value="month.value">{{month.text}}</option>
                            </select>                            
                            <select v-else class="form-control form-control-inline" v-model="form.startMonth" >
                              <option
                              v-for="(month, monthIndex) in monthOpt"
                              :key="`service-month-${monthIndex}`"
                              :value="month.value">{{month.text}}</option>
                            </select>
                            <span class="text">～</span>
                            <select class="form-control form-control-inline" v-model="form.endYear">
                              <option
                              v-for="(year, yearIndex) in yearOpt"
                              :key="`service-year-${yearIndex}`"
                              :value="year.value">{{year.text}}</option>
                            </select>
                            <select class="form-control form-control-inline" v-model="form.endMonth">
                              <option
                              v-for="(month, monthIndex) in monthOpt"
                              :key="`service-month-${monthIndex}`"
                              :value="month.value">{{month.text}}</option>
                            </select>
                        </div>
                        <div class="col-2">
                          <!--
                          <div class="checkbox checkbox-inline">
                                <input type="checkbox" v-model="form.allyear" id="allyear" value="true" @change="allYearOpt()">
                                <label for="allyear">全年度累計</label>
                          </div>  -->                                               
                          <a @click="searchData()" class="btn btn-primary mt-0">查詢</a>
                        </div>
                        <div class="col-3">
                          <p class="text-green cus-p">本年度強制調撥</p>
                          <p class="text-green cus-p">期限內應撥月份為{{currentYear-1}}/11-{{currentYear}}/10</p>
                          <p class="text-green cus-p">全年度應撥月份為{{currentYear-1}}/10-{{currentYear}}/9</p>
                          <a target="_blank" href="https://clearning.cathaylife.com.tw/channel/channel-room/67a6c9bdbe21a0562869fabf/67aadda992dc5f5142e195d0/empty/6943ab2422c39a02d4182911"><span class="text-blue">調撥期限說明</span></a>
                        </div>
                        <div class="col-11" >
                          <div class="checkbox checkbox-inline">
                              <input type="checkbox" v-model="form.intime" id="intime" value="true" :disabled="currentMonthChk">
                              <label for="intime">期限內</label>
                          </div>
                          <!-- <div v-if="searchType==1" class="checkbox checkbox-inline">
                              <input type="checkbox" v-model="form.no_estrange" id="no_estrange" value="true">
                              <label for="no_estrange">不含未訪件合計</label>
                          </div> -->                    
                          <div v-if="searchType==1" class="checkbox checkbox-inline">
                              <input type="checkbox" v-model="currentMonthChk" id="chk_currentMonthChk" value="true" :disabled="form.intime">
                              <label for="chk_currentMonthChk">查詢{{currentMonth}}月未訪件數</label>
                          </div>
                        </div>
                    </div>
                  </form>  
                    <div class="breadcrumb row" v-if="tableRow && tableRow.length">
                        <label class="col-1 text-right">路徑</label>
                        <div class="col-7">
                            <ul class="breadcrumb-list">
                                <!-- <li :class="{
                                'active': currentLevel == null
                                }">
                                    <a role="button" @click="currentLevel = null">全部</a>
                                </li> -->
                                <li class="bread"
                                :class="{
                                'active': bread.level === currentLevel
                                }"
                                v-for="(bread, i) in breadCrumbs"
                                :key="`bread-${i}`">
                                    <a role="button" @click="currentLevel = bread.level">{{bread.name | getCedvnmText}}</a>
                                </li>
                            </ul>
                        </div>
                        <div class="col-4 text-left">
                          <a @click="downloadData()" class="btn btn-default" v-if="searchType==1">下載本頁資料</a>
                          <a  @click.prevent="panelOpen('ceadcdChooseModalOpen')" class="btn btn-default" v-if="searchType==1">下載轄下資料</a>
                        </div>
                    </div> 
                  </div>                 
                <div class="col-12" v-if="searchType==1" :class="{'section-loading': isLoading}">                              
                    <table class="table datatable insurance-green">
                        <thead>
                            <tr>
                                <th v-if="currentLevel == '1'" rowspan="2" width="100">系統別</th>
                                <th v-else-if="currentLevel == '2'" rowspan="2" width="150">區部</th>
                                <th v-else-if="currentLevel == '3'" rowspan="2" width="100">通訊處</th>     
                                <th colspan="3" class="text-center">離/退(撥出)</th>
                                <th colspan="3" class="text-center">2年內/AFP/CFP(撥入)</th>
                                <th colspan="3" class="text-center">全單位未訪件(已無使用)</th>
                                <th colspan="3" class="text-center">合計</th>
                            </tr>
                            <tr>
                                <th class="text-center">應撥保戶</th>
                                <th class="text-center">已撥保戶</th>
                                <th class="text-center">完成率</th>
                                <th class="text-center">應撥保戶</th>
                                <th class="text-center">已撥保戶</th>
                                <th class="text-center">完成率</th>
                                <th class="text-center">應撥保戶</th>
                                <th class="text-center">已撥保戶</th>
                                <th class="text-center">完成率</th>
                                <th class="text-center">應撥保戶</th>
                                <th class="text-center">已撥保戶</th>
                                <th class="text-center">完成率</th>
                            </tr>
                        </thead>
                        <tbody v-if="tableRow && tableRow.length">
                          <tr v-for="(row, rid) in tableRow"
                          :key="`row-${rid}`">
                            <td>
                              <a v-if="breadCrumbs.length < 3 && row.child" @click="tabOneLinkSearch(row.ceadnm, row.ceadcd)" class="link text-underline">{{row.ceadnm | getCedvnmText}}</a>
                              <span v-else>{{row.ceadnm | getCedvnmText}}</span>
                            </td>
                            <td class="text-right">{{row.a_cust}}</td>
                            <td v-if ="form.intime" class="text-right">{{row.a_done1}}</td>
                            <td v-else class="text-right">{{row.a_done}}</td>
                            <td v-if ="form.intime" class="text-right">{{row.a_rate1}}%</td>
                            <td v-else class="text-right">{{row.a_rate}}%</td>
                            <td class="text-right">{{row.c_cust}}</td>
                            <td v-if ="form.intime" class="text-right">{{row.c_done1}}</td>
                            <td v-else class="text-right">{{row.c_done}}</td>
                            <td v-if ="form.intime" class="text-right">{{row.c_rate1}}%</td>
                            <td v-else class="text-right">{{row.c_rate}}%</td>
                            <td v-if ="form.no_estrange" class="text-right">--</td>
                            <td v-else class="text-right">{{row.n_cust}}</td>
                            <td v-if ="form.no_estrange" class="text-right">--</td>
                            <td v-else-if="form.intime" class="text-right">{{row.n_done1}}</td>
                            <td v-else class="text-right">{{row.n_done}}</td>
                            <td v-if ="form.no_estrange" class="text-right">--</td>
                            <td v-else-if="form.intime" class="text-right">{{row.n_rate1}}%</td>
                            <td v-else class="text-right">{{row.n_rate}}%</td>
                            <td v-if ="form.no_estrange" class="text-right">{{f_int(row.abc_cust)-f_int(row.n_cust)}}</td>
                            <td v-else class="text-right">{{row.abc_cust}}</td>
                            <td v-if ="form.no_estrange && form.intime" class="text-right">{{f_int(row.abc_done1)-f_int(row.n_done1)}}</td> 
                            <td v-else-if ="form.no_estrange && !form.intime" class="text-right">{{f_int(row.abc_done)-f_int(row.n_done)}}</td> 
                            <td v-else-if ="!form.no_estrange && form.intime" class="text-right">{{row.abc_done1}}</td>
                            <td v-else class="text-right">{{row.abc_done}}</td>
                            <td v-if ="form.no_estrange && form.intime" class="text-right">{{f_int(parseFloat(((f_int(row.abc_done1)-f_int(row.n_done1))/(f_int(row.abc_cust)-f_int(row.n_cust))*100)).toFixed(2))}}%</td>
                            <td v-else-if ="form.no_estrange && !form.intime" class="text-right">{{f_int(parseFloat(((f_int(row.abc_done)-f_int(row.n_done))/(f_int(row.abc_cust)-f_int(row.n_cust))*100)).toFixed(2))}}%</td>                           
                            <td v-else-if ="!form.no_estrange && form.intime" class="text-right">{{row.abc_rate1}}%</td>
                            <td v-else class="text-right">{{row.abc_rate}}%</td>
                          </tr>
                        </tbody>
                        <tbody v-else-if="currentRowID && !tableRow.length">
                            <tr>
                                <td class="empty-block bg-white" colspan="13">
                                    <h1 class="bg-white">無任何資料</h1>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td class="empty-block bg-white" colspan="13">
                                    <h1 class="bg-white">點擊查詢顯示資料</h1>
                                </td>
                            </tr>
                        </tbody>
                        <!-- <tfoot v-if="tableRow && tableRow.length">
                          <tr class="bg-white">
                            <th>合計</th>
                            <th class="text-right">{{countTotal('leave1') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('leave2') | numberFormat}}</th>
                            <th class="text-right">{{(countTotal('leave2') / countTotal('leave1') * 100).toFixed(2)}} %</th>
                            <th class="text-right">{{countTotal('AFP1') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('AFP2') | numberFormat}}</th>
                            <th class="text-right">{{(countTotal('AFP2') / countTotal('AFP1') * 100).toFixed(2)}} %</th>
                            <th class="text-right">{{countTotal('allleave1') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('allleave2') | numberFormat}}</th>
                            <th class="text-right">{{(countTotal('allleave2') / countTotal('allleave1') * 100).toFixed(2)}} %</th>
                            <th class="text-right">{{countTotal('leave1') + countTotal('AFP1') + countTotal('allleave1') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('leave2') + countTotal('AFP2') + countTotal('allleave2') | numberFormat}}</th>
                            <th class="text-right">{{((countTotal('leave2') + countTotal('AFP2') + countTotal('allleave2')) / (countTotal('leave1') + countTotal('AFP1') + countTotal('allleave1')) * 100).toFixed(2)}}%</th>
                          </tr>
                        </tfoot> -->
                    </table>
                    <div v-if="tableRow && tableRow.length">
                        <p>
                            <span class="d-inline-block align-top">2年內(撥入)：</span>
                            <span class="d-inline-block">
                              應撥保戶=新人晉升時件數差額=下限-目前保戶數<br/>
                              已撥保戶=採個別業務員計算，if 差額=N=20，已撥保戶最多=N=20
                            </span>
                        </p>

                        <p>
                            月份 ➔ 對離/退職人員，係指離職生效日對應月份<br/>
                            月份 ➔ 對2年內新人，應撥=(晉升時)期初件數(差額)<br/>
                            108/12以前的離/退(撥出)數字為歷史資料不再更新<br/>
                            107/12以前的2年內/AFP/CFP(撥入) 數字為歷史資料不再更新<br/>
                            如有疑問，請洽總公司業務部業務企劃科，(02)27551399#{{ contactInfo.contact_tel }}
                        </p>
                    </div>
                </div>

                <div class="col-12" v-if="searchType==2" :class="{'section-loading': isLoading}">                                   
                    <table class="table datatable insurance-green" v-if="searchType==2">
                        <thead>
                            <tr>
                                <th v-if="currentLevel == '1'" rowspan="2" width="100">系統別</th>
                                <th v-else-if="currentLevel == '2'" rowspan="2" width="200">區部</th>
                                <th v-else-if="currentLevel == '3'" rowspan="2" width="200">通訊處</th> 
                                <th class="text-center">離/退業務員</th>
                                <th class="text-center">應撥保戶</th>
                                <th class="text-center">未撥保戶</th>
                                <th class="text-center">已撥保戶</th>
                                <!--<th class="text-center">已撥保戶(逾期)</th>-->
                                <th class="text-center">完成率</th>
                            </tr>
                        </thead>
                        <tbody v-if="tableRow && tableRow.length">
                          <tr v-for="(row, rid) in tableRow"
                          :key="`row-${rid}`">
                            <td>
                              <a v-if="breadCrumbs.length < 3 && row.child" @click="tabTwoLinkSearch(row.ceadnm, row.ceadcd)" class="link text-underline">{{row.ceadnm | getCedvnmText}}</a>
                              <span v-else>{{row.ceadnm | getCedvnmText}}</span>
                            </td>
                            <td class="text-right">{{row.a_ag}}</td>
                            <td class="text-right">{{row.a_cust}}</td>
                            <td v-if ="form.intime" class="text-right">{{ row.a_remain1 }}</td>
                            <td v-else class="text-right">{{ row.a_remain }}</td>
                            <td v-if ="form.intime" class="text-right">{{row.a_done1}}</td>
                            <td v-else class="text-right">{{row.a_done1 + row.a_done2}}</td>
                            <!--<td class="text-right">{{row.a_done2}}</td>-->
                            <td v-if ="form.intime" class="text-right">{{f_int(parseFloat((f_int(row.a_done1)/f_int(row.a_cust))*100).toFixed(2))}}%</td>
                            <td v-else class="text-right">{{row.a_rate}}%</td>
                          </tr>
                        </tbody>
                        <tbody v-else-if="currentRowID && !tableRow.length">
                            <tr>
                                <td class="empty-block bg-white" colspan="13">
                                    <h1 class="bg-white">無任何資料</h1>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td class="empty-block bg-white" colspan="13">
                                    <h1 class="bg-white">點擊查詢顯示資料</h1>
                                </td>
                            </tr>
                        </tbody>
                        <!-- <tfoot v-if="tableRow && tableRow.length">
                          <tr class="bg-white">
                            <th class="text-left">合計</th>
                            <th class="text-right">{{countTotal('client') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('clientIsTransfer') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('clientNotTransferInTime') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('clientNotTransferDelay') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('complete')}}%</th>
                          </tr>
                        </tfoot> -->
                    </table>
                    <div v-if="tableRow && tableRow.length">
                        <p>
                            <span class="d-inline-block align-top">2年內(撥入)：</span>
                            <span class="d-inline-block">
                              應撥保戶=新人晉升時件數差額=下限-目前保戶數<br/>
                              已撥保戶=採個別業務員計算，if 差額=N=20，已撥保戶最多=N=20
                            </span>
                        </p>
                        <p>
                            月份 ➔ 對離/退職人員，係指離職生效日對應月份<br/>
                            月份 ➔ 對2年內新人，應撥=(晉升時)期初件數(差額)<br/>
                            108/12以前的離/退(撥出)數字為歷史資料不再更新<br/>
                            如有疑問，請洽總公司業務部業務企劃科，(02)27551399#{{ contactInfo.contact_tel }}
                        </p>
                    </div>
                </div>

                <div class="col-12" v-if="searchType==3" :class="{'section-loading': isLoading}">                                 
                    <table class="table datatable insurance-green" v-if="searchType==3">
                        <thead v-if="breadCrumbs.length < 4">
                             <tr>
                                <th v-if="breadCrumbs.length < 2" width="18%" rowspan="2">系統別</th>
                                <th v-else-if="breadCrumbs.length==2" width="18%" rowspan="2">區部</th>
                                <th v-else-if="breadCrumbs[breadCrumbs.length-1].target=='lev6'" width="18%" rowspan="2">業務員姓名</th>
                                <th v-else width="18%" rowspan="2">單位</th>                 
                                <th colspan="5" class="text-center">2年內新人</th>
                                <th colspan="5" class="text-center">AFP & CFP</th>
                            </tr>
                            <tr>
                                <th class="text-center">業務員</th>
                                <th class="text-center">應撥<br>保戶</th>
                                <th class="text-center">未撥<br>保戶</th>
                                <th class="text-center">已撥保戶</th>
                                <!--<th class="text-center">已撥保戶<br>(逾期)</th>-->
                                <th class="text-center">完成率</th>
                                <th class="text-center">業務員</th>
                                <th class="text-center">應撥<br>保戶</th>
                                <th class="text-center">未撥<br>保戶</th>
                                <th class="text-center">已撥保戶</th>
                                <!--<th class="text-center">已撥保戶<br>(逾期)</th>-->
                                <th class="text-center">完成率</th>
                            </tr>
                        </thead>
                        <thead v-else>
                             <tr>
                                <th v-if="breadCrumbs.length < 2" rowspan="2">系統別</th>
                                <th v-else-if="breadCrumbs.length==2" rowspan="2">區部</th>
                                <th v-else-if="breadCrumbs[breadCrumbs.length-1].target=='lev6'" rowspan="2">業務員姓名</th>
                                <th v-else rowspan="2">單位</th>                 
                                <th class="text-center">2年內新人</th>
                                <th class="text-center">AFP & CFP</th>
                            </tr>
                            <tr>
                                <th class="text-center">未撥保戶</th>
                                <th class="text-center">未撥保戶</th>
                            </tr>
                        </thead>                        
                        <tbody v-if="tableRow && tableRow.length && breadCrumbs.length < 4">
                          <tr v-for="(row, rid) in tableRow"
                          :key="`row-${rid}`">
                            <td>
                              <a v-if="breadCrumbs.length < 6 && row.child" @click="tabThreeLinkSearch(row.ceadnm, row.ceadcd)" class="link text-underline">{{row.ceadnm | getCedvnmText}}</a>   
                              <span v-else>{{row.ceadnm | getCedvnmText}}</span> 
                            </td> 
                            <td class="text-right">{{row.e_ag }}</td>
                            <td class="text-right">{{row.e_cust }}</td>
                            <td v-if ="form.intime" class="text-right">{{ row.e_remain1 }}</td>
                            <td v-else class="text-right">{{ row.e_remain }}</td>
                            <td v-if ="form.intime" class="text-right">{{row.e_done1 }}</td>
                            <td v-else class="text-right">{{row.e_done1 + row.e_done2 }}</td>
                            <!--<td class="text-right">{{row.e_done2 }}</td>-->
                            <td v-if ="form.intime" width="80px" class="text-right">{{f_int(parseFloat((f_int(row.e_done1)/f_int(row.e_cust))*100).toFixed(2))}}%</td>
                            <td v-else width="80px" class="text-right">{{row.e_rate}}%</td>
                            <td class="text-right">{{row.h_ag }}</td>
                            <td class="text-right">{{row.h_cust }}</td>
                            <td v-if ="form.intime" class="text-right">{{ row.h_remain1 }}</td>
                            <td v-else class="text-right">{{ row.h_remain }}</td>
                            <td v-if ="form.intime" class="text-right">{{row.h_done1 }}</td>
                            <td v-else class="text-right">{{row.h_done1 + row.h_done2}}</td>
                            <!--<td class="text-right">{{row.h_done2 }}</td>-->
                            <td v-if ="form.intime" width="80px" class="text-right">{{f_int(parseFloat((f_int(row.h_done1)/f_int(row.h_cust))*100).toFixed(2))}}%</td>
                            <td v-else width="80px" class="text-right">{{row.h_rate}}%</td>
                          </tr>
                        </tbody>
                        <!-- 2年內新人AFP/FCP撥入_專招lv4-lv5層 -->
                        <tbody v-else-if="tableRow && tableRow.length && breadCrumbs.length < 6 && endLv==true "> 
                          <tr v-for="(row, rid) in tableRow"
                          :key="`row-${rid}`">
                            <td>
                              <a v-if="breadCrumbs.length < 5 && row.child " @click="tabThreeLinkSearch(row.ceadnm, row.ceadcd)" class="link text-underline">{{row.ceadnm | getCedvnmText}}</a>   
                              <span v-else>{{row.ceadnm | getCedvnmText}}</span>
                            </td>
                            <td class="text-right">{{row.e_done }}</td>
                            <td class="text-right">{{row.h_done }}</td>
                          </tr>
                        </tbody>
                        <!-- 2年內新人AFP/FCP撥入_展業lv4-lv6層 -->   
                        <tbody v-else-if="tableRow && tableRow.length && breadCrumbs.length < 7 && endLv==false"> 
                          <tr v-for="(row, rid) in tableRow"
                          :key="`row-${rid}`">
                            <td>
                              <a v-if="breadCrumbs.length < 6 && row.child " @click="tabThreeLinkSearch(row.ceadnm, row.ceadcd)" class="link text-underline">{{row.ceadnm | getCedvnmText}}</a>   
                              <span v-else>{{row.ceadnm | getCedvnmText}}</span>
                              <p>{{row.cedvno}}</p>
                            </td>
                            <td class="text-right">{{row.e_done }}</td>
                            <td class="text-right">{{row.h_done }}</td>
                          </tr>
                        </tbody>                                                
                        <tbody v-else-if="currentRowID && !tableRow.length">
                            <tr>
                                <td class="empty-block bg-white" colspan="13">
                                    <h1 class="bg-white">無任何資料</h1>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-show="!tableRow">
                            <tr>
                                <td class="empty-block bg-white" colspan="13">
                                    <h1 class="bg-white">點擊查詢顯示資料</h1>
                                </td>
                            </tr>
                        </tbody>
                        <!-- <tfoot v-if="tableRow && tableRow.length">
                          <tr class="bg-white">
                            <th class="text-left">合計</th>
                            <th class="text-right">{{countTotal('twoyearSales') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('twoyearClient') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('twoyearClentNotTransfer') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('twoyearClentHasTransfer') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('twoyearClentDelayTransfer') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('twoyearComplete')}}%</th>
                            <th class="text-right">{{countTotal('AFPSales') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('AFPClient') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('AFPClentNotTransfer') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('AFPClentHasTransfer') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('AFPClentDelayTransfer') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('AFPComplete')}}%</th>
                          </tr>
                        </tfoot> -->
                    </table>
                   
                    <div v-if="tableRow && tableRow.length">
                        <p>
                            <span class="d-inline-block align-top">2年內(撥入)：</span>
                            <span class="d-inline-block">
                              應撥保戶=新人晉升時件數差額=下限-目前保戶數<br/>
                              已撥保戶=採個別業務員計算，if 差額=N=20，已撥保戶最多=N=20
                            </span>
                        </p>

                        <p>
                            107/12以前的2年內/AFP/CFP(撥入) 數字為歷史資料不再更新<br/>
                            如有疑問，請洽總公司業務部業務企劃科，(02)27551399#{{ contactInfo.contact_tel }}
                        </p>
                    </div>
                </div>

                <div class="col-12" v-if="searchType==4" :class="{'section-loading': isLoading}">
                  <table class="table datatable insurance-green">
                    <thead v-if="breadCrumbs.length < 4">
                      <tr>
                        <th v-if="breadCrumbs.length < 2" rowspan="2">系統別</th>
                        <th v-else-if="breadCrumbs.length==2" rowspan="2">區部</th>
                        <th v-else-if="breadCrumbs[breadCrumbs.length-1].target=='lev6'" rowspan="2">業務員姓名</th>  
                        <th v-else rowspan="2">單位</th>                    
                        <th class="text-center">業務員</th>
                        <th class="text-center">應撥保戶</th>
                        <th class="text-center">未撥保戶</th>
                        <th class="text-center">已撥保戶</th>
                        <!--<th class="text-center">已撥保戶(逾期)</th>-->
                        <th class="text-center">完成率</th>
                      </tr>
                    </thead>
                    <thead v-else>
                        <tr>
                          <th v-if="breadCrumbs.length < 2" rowspan="2">系統別</th>
                          <th v-else-if="breadCrumbs.length==2" rowspan="2">區部</th>
                          <th v-else-if="breadCrumbs[breadCrumbs.length-1].target=='lev6' || breadCrumbs[breadCrumbs.length-1].target=='lev5' && breadCrumbs[1].ceadcd ==1 " rowspan="2">業務員姓名</th>    
                          <th v-else rowspan="2">單位</th>                       
                          <th class="text-center">未撥保戶</th>
                        </tr>
                    </thead>                      
                    <tbody v-if="tableRow && tableRow.length && breadCrumbs.length < 4">
                      <tr v-for="(row, rid) in tableRow"
                      :key="`row-${rid}`">
                        <td>
                          <a v-if="breadCrumbs.length < 6 && row.child " @click="tabFourLinkSearch(row.ceadnm, row.ceadcd)" class="link text-underline">{{row.ceadnm | getCedvnmText}}</a>   
                          <span v-else>{{row.ceadnm | getCedvnmText}}</span>
                        </td>
                        <td class="text-right">{{row.n_ag }}</td>
                        <td class="text-right">{{row.n_cust }}</td>
                        <td v-if ="form.intime" class="text-right">{{ row.n_remain1 }}</td>
                        <td v-else class="text-right">{{ row.n_remain }}</td>
                        <td v-if ="form.intime" class="text-right">{{row.n_done1}}</td>
                        <td v-else  class="text-right">{{f_int(row.n_done1) + f_int(row.n_done2)}}</td>
                        <!--<td class="text-right">{{row.n_done2 }}</td>-->
                        <td v-if ="form.intime" class="text-right">{{f_int(parseFloat((f_int(row.n_done1)/f_int(row.n_cust))*100).toFixed(2))}}%</td>
                        <td v-else class="text-right">{{row.n_rate}}%</td>
                      </tr>
                    </tbody>
                    <!-- 全單位未訪件_專招lv4-lv5層 -->
                    <tbody v-else-if="tableRow && tableRow.length && breadCrumbs.length < 6 && endLv==true "> 
                      <tr v-for="(row, rid) in tableRow"
                      :key="`row-${rid}`">
                        <td>
                          <a v-if="breadCrumbs.length < 5 && row.child " @click="tabFourLinkSearch(row.ceadnm, row.ceadcd)" class="link text-underline">{{row.ceadnm | getCedvnmText}}</a>   
                          <span v-else>{{row.ceadnm | getCedvnmText}}</span>
                        </td>
                        <td class="text-right">{{row.n_done }}</td>
                      </tr>
                    </tbody>
                    <!-- 全單位未訪件_展業lv4-lv6層 -->   
                    <tbody v-else-if="tableRow && tableRow.length && breadCrumbs.length < 7 && endLv==false"> 
                      <tr v-for="(row, rid) in tableRow"
                      :key="`row-${rid}`">
                        <td>
                          <a v-if="breadCrumbs.length < 7 && row.child " @click="tabFourLinkSearch(row.ceadnm, row.ceadcd)" class="link text-underline">{{row.ceadnm | getCedvnmText}}</a>   
                          <span v-else>{{row.ceadnm | getCedvnmText}}</span>
                        </td> 
                        <td class="text-right">{{row.n_done }}</td>
                      </tr>
                    </tbody>                                                                
                    <tbody v-else-if="currentRowID && !tableRow.length">
                        <tr>
                            <td class="empty-block bg-white" colspan="7">
                                <h1 class="bg-white">無任何資料</h1>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-show="!tableRow">
                        <tr>
                            <td class="empty-block bg-white" colspan="7">
                                <h1 class="bg-white">點擊查詢顯示資料</h1>
                            </td>
                        </tr>
                    </tbody>
                    <!-- <tfoot v-if="tableRow && tableRow.length">
                      <tr class="bg-white">
                        <th class="text-left">合計</th>
                        <th class="text-right">{{countTotal('sales') | numberFormat}}</th>
                        <th class="text-right">{{countTotal('client') | numberFormat}}</th>
                        <th class="text-right">{{countTotal('clentNotTransfer') | numberFormat}}</th>
                        <th class="text-right">{{countTotal('clentHasTransfer') | numberFormat}}</th>
                        <th class="text-right">{{countTotal('clentDelayTransfer') | numberFormat}}</th>
                        <th class="text-right">{{countTotal('complete')}}%</th>
                      </tr>
                    </tfoot> -->
                  </table>
                </div>
            </div>
        </div>
      </div>
    </div>

    <ceadcd-Choose-modal
      :open="ceadcdChooseModalOpen"
      :dis="this.dis"
      @close="panelClose('ceadcdChooseModalOpen')"
      @choose="chooseCeadcd"
    />

  </main>
</template>



<script>
import {mapActions, mapGetters} from 'vuex'
import {commonMixin} from '@/mixins/common'
import TabHeader from '@/desktop/components/manager/TabHeader'
import Avatar from '@/components/Avatar'
import Level from '@/components/Level'
import { debuglog } from 'util';
import ceadcdChooseModal from '../manager/condition/components/ceadcdChooseModal'
import { getmandatoryAllocationSummary ,forcedTransferPersonnel ,newcomerDialinWithin ,allUnitdetachment, dowlnloadMandatoryAllocationSummary, getContactInfoBySerNo} from '../../../service';

export default {
  name: 'TransferTab4',
  mixins: [commonMixin],
  components: {
    TabHeader, Level, Avatar,ceadcdChooseModal
  },
  computed: {
    tableRow () {
        this.checkBreadCrumbs()
        return this.dataTree[this.currentLevel - 1] //type1
    },
  },
  data () {
    return {
      yearOpt: [],
      monthOpt: [],
      currentLevel: 0,
      apiTarget: {}, //系統別_物件
      breadCrumbs: [], //麵包屑
      dataTree: [],   
      isLoading: false,
      ceadcdChooseModalOpen: false,
      dis: '4',
      choose:'', 
      form:{
        // vip: false,
        startYear: '',
        startMonth: '',
        endYear: '',
        endMonth: ''
      },                 
      order: {
          index: 1,
          asc: true
      },
      lv:'',
      endLv:false,
      searchType: 1,
      currentRowID: 0,
      currentMonthChk: false,
      currentMonth: String(new Date().getMonth() +1),
      rolePermission: true,
      currentYear: new Date().getFullYear()-1911,
      // checkModalOpen: false,
      // transferModalOpen: false,
      contactInfo: []
    }
  },
  watch: {
      'searchType': 'changeData'
  },  
  methods: {
    ...mapActions([
      'setPageLock'
    ]),
    searchData () { //201901 - 201907 查詢
      switch(Number(this.searchType)) {
        case 1:
          this.tabOneSearch()
          break;
        case 2:
          this.tabTwoSearch()
          break;
        case 3:
          this.tabThreeSearch()
          break;
        case 4:
           this.tabFourSearch()
          break;
      }
    }, 
    tabOneSearch () {  // 強制調撥總表查詢
      this.currentLevel = 0
      this.dataTree = []
      this.breadCrumbs = []    
      this.tabOneLinkSearch() //查詢連結資料 
    }, 
    tabTwoSearch (){ //離退職人員撥出
      this.currentLevel = 0
      this.dataTree = []
      this.breadCrumbs = []    
      this.tabTwoLinkSearch()        
    }, 
    tabThreeSearch(){ //2年內新人AFP/FCP撥入
      this.currentLevel = 0
      this.dataTree = []
      this.breadCrumbs = []    
      this.tabThreeLinkSearch()             
    },
    tabFourSearch(){ //全單位未訪件
      this.currentLevel = 0
      this.dataTree = []
      this.breadCrumbs = []    
      this.tabFourLinkSearch() //查詢連結資料   
    },
    tabOneLinkSearch(ceadnm, ceadcd){
      if (this.isLoading) return false //防止連點麵包屑
      let target = this.searchTarget()
      this.apiTarget = {
        level: this.currentLevel + 1,
        target: target,
        ceadcd: ceadcd,
        name: ceadnm
      }
      let report = {}
      report.startDate = this.form.startYear+this.form.startMonth
      report.endDate = this.form.endYear+this.form.endMonth
      // lev2因為專展合併，因此讀取全部
      report.ceadcd = target === "lev2" ? "null" : ceadcd;
      report.monthChk = this.currentMonthChk ? "Y" : "N"
      if(this.dataCheck()){
        this.isLoading = true
        getmandatoryAllocationSummary(this.$store.state.userInfo.id, target, report).then(result => {
          if(result.header && result.header.status === '200') { 
            let checkedDatas = result.body['query_stats_' + target].map(item => {
              if(item.ceadcd == '0') {
                item['child'] = false
                return item
              } else {
                item['child'] = true
                return item
              }
            })
            checkedDatas.sort(this.sortCompareFun())
            this.dataTree.push(checkedDatas)
            this.currentLevel++
            this.syncBreadCrumbs()    
          } else {
            if(result.header.message) {
              this.$toast.info({title: result.header.message})
            } else {
              this.$toast.info({title: '查詢失敗,請重新操作'})
            }
          }
          this.isLoading = false
        })  
      }          
    },  
    tabTwoLinkSearch(ceadnm, ceadcd){
      if (this.isLoading) return false
      let target = this.searchTarget()
      this.apiTarget = {
        level: this.currentLevel + 1,
        target: target,
        ceadcd: ceadcd,
        name: ceadnm
      }
      let report = {}
      report.startDate = this.form.startYear+this.form.startMonth
      report.endDate = this.form.endYear+this.form.endMonth
      if(ceadcd == undefined){
        ceadcd =""
      }
      // lev2因為專展合併，因此讀取全部
      report.ceadcd = target === "lev2" ? "null" : ceadcd;
      if(this.dataCheck()){
        this.isLoading = true
        forcedTransferPersonnel(this.$store.state.userInfo.id, target, report).then(result => {
          if(result.header && result.header.status === '200') {
            let checkedDatas = result.body.map(item => {
              if(item.ceadcd == '0') {
                item['child'] = false
                return item
              } else {
                item['child'] = true
                return item
              }
            })
            checkedDatas.sort(this.sortCompareFun())
            this.dataTree.push(checkedDatas)
            this.currentLevel++
            this.syncBreadCrumbs()    
          } else {
            if(result.header.message) {
              this.$toast.info({title: result.header.message})
            } else {
              this.$toast.info({title: '查詢失敗,請重新操作'})
            }
          }
              this.isLoading = false
        })  
      }          
    },
    tabThreeLinkSearch(ceadnm, ceadcd){
      if (this.isLoading) return false
      let target = this.searchTargetAFP()
      this.apiTarget = {
        level: this.currentLevel + 1,
        target: target,
        ceadcd: ceadcd,
        name: ceadnm
      }
      let report = {}
      report.startDate =this.form.startYear+this.form.startMonth
      report.endDate =  this.form.endYear+this.form.endMonth
      if(ceadcd == undefined){
        ceadcd =""
      }
      // lev2因為專展合併，因此讀取全部
      report.ceadcd = target === "lev2" ? "null" : ceadcd;
      if(this.dataCheck()){
        this.isLoading = true
        newcomerDialinWithin(this.$store.state.userInfo.id, this.lv, report).then(result => {
          if(result.header && result.header.status === '200') {
                let checkedDatas = result.body['query_stats_e_' + target].map(item => {
                  if(item.ceadcd == '0') {
                    item['child'] = false
                    return item
                  } else {
                    item['child'] = true
                    return item
                  }
                })
                  checkedDatas.sort(this.sortCompareFun())
                  this.dataTree.push(checkedDatas)
                  this.currentLevel++
                  this.syncBreadCrumbs()            
          } else {
            if(result.header.message) {
              this.$toast.info({title: result.header.message})
            } else {
              this.$toast.info({title: '查詢失敗,請重新操作'})
            }
          }
          this.isLoading = false
          this.registerHanlink()
        })  
      }          
    },   
    tabFourLinkSearch(ceadnm, ceadcd){
      if (this.isLoading) return false
      let target = this.searchTargetAFP()
      this.apiTarget = {
        level: this.currentLevel + 1,
        target: target,
        ceadcd: ceadcd,
        name: ceadnm
      }
      let report = {}
      report.startDate =this.form.startYear+this.form.startMonth
      report.endDate =  this.form.endYear+this.form.endMonth
      if(ceadcd == undefined){
        ceadcd =""
      }
      report.ceadcd = ceadcd
      if(this.dataCheck()){
        this.isLoading = true
        allUnitdetachment(this.$store.state.userInfo.id, this.lv, report).then(result => {
          if(result.header && result.header.status === '200') {
                let checkedDatas = result.body['query_stats_n_' + target].map(item => {
                  if(item.ceadcd == '0' || result.body.hasOwnProperty('query_stats_n_lev6')) {
                    item['child'] = false
                    return item
                  } else {
                    item['child'] = true
                    return item
                  }
                })
                  checkedDatas.sort(this.sortCompareFun())
                  this.dataTree.push(checkedDatas)
                  this.currentLevel++
                  this.syncBreadCrumbs()            
          } else {
            if(result.header.message) {
              this.$toast.info({title: result.header.message})
            } else {
              this.$toast.info({title: '查詢失敗,請重新操作'})
            }
          }
          this.isLoading = false
          this.registerHanlink()
        })  
      }          
    },                  
    checkBreadCrumbs() { 
      if(this.dataTree.length > this.currentLevel) {
        this.dataTree.length = this.currentLevel
        this.breadCrumbs.length = this.currentLevel
      }
    },  
    syncBreadCrumbs() { //檢查麵包屑
      if(this.currentLevel==1) {
        this.breadCrumbs = [{level: 1, target: 'lev1', ceadcd: '0', name: '全部'}]
      } else {
        this.breadCrumbs.push(this.apiTarget)
      }
    },      
    searchTarget() { //強制調撥總表 & 離退職人員撥出
      if(this.breadCrumbs.length == 0) {
        return 'lev1'
      } else {
        let lastTarget = this.breadCrumbs[this.breadCrumbs.length -1].target

        switch(lastTarget) {
          case 'lev1':
            return 'lev2' //區部
          case 'lev2':
            return 'lev3' //通訊處
          default:
            return 'error'
        }
      }
    },   
    searchTargetAFP() { //2年內新人AFP/FCP撥入 & 強制調撥全單位未訪件
      if(this.breadCrumbs.length == 0) {
        this.lv = 1
        return 'lev1'
      } else {
        let lastTarget = this.breadCrumbs[this.breadCrumbs.length -1].target
        // 權限
        if(lastTarget == 'lev3') {
          if(this.breadCrumbs[1].ceadcd == '1') {
            // 專招
            lastTarget += '_1'
          } else {
            // 展業
            lastTarget += '_4'
          }
        }

        switch(lastTarget) {
          case 'lev1':
            this.lv = 2  
            return 'lev2'
          case 'lev2':
            this.lv = 3  
            return 'lev3'
          case 'lev3_1':
            this.lv = 6
            this.endLv = true;
            return 'lev51'
          case 'lev3_4':
            this.lv = 4
            return 'lev44'
          case 'lev44':
            this.lv = 5  
            this.endLv = false;
            return 'lev54'
          case 'lev54':
            this.lv = 7  
            return 'lev6'
          case 'lev51':
            this.lv = 7  
            return 'lev6'
          default:
            return 'error' 
        }
      }
    },  
    sortCompareFun() {
      return function(a, b) {
        if(a['ceadcd'] == '0') {return 1}
        if(b['ceadcd'] == '0') {return -1}
        let result = (a['ceadcd'] < b['ceadcd']) ? -1 : (a['ceadcd'] > b['ceadcd']) ? 1 : 0;
        return result;
      }
    },    
    dataCheck () { 
      const nowDate = new Date(`${moment().year()}-${moment().month() + 2}`)
      let startDate = this.form.startYear+'-'+this.form.startMonth
      let endDate = this.form.endYear+'-'+this.form.endMonth
      if(Date.parse(startDate) > Date.parse(endDate)){
          this.setToastMsg('起年月不可大於迄年月')
          return false
      }
      if(Date.parse(endDate) > nowDate) {
          this.setToastMsg('迄年月不可大於當前年月')
          return false
      }       
      return true
    }, 
    changeData () {
      this.dataTree = []
      this.currentRowID = 0;
      this.yearOpt = []
      this.monthOpt = []
      this.initYearOpt()
      this.initMonthOpt()
      this.currentMonthChk = false
    },
    initYearOpt() {
      let westYear = new Date().getFullYear()
      for(var i=2015; i<=westYear; i++) {
        let selectItem = {
          value: String(i),
          text: `${i - 1911}年`
        }
        this.yearOpt.push(selectItem)
      }
      let currentWestYear = String(westYear)
      this.form.startYear = currentWestYear
      this.form.endYear = currentWestYear

      let isallyear = this.form.allyear ? '1' : '0'
      if(isallyear === '1'){this.form.startYear = '2019'} else {this.form.startYear = String(new Date().getFullYear())}
    },    
    allYearOpt() {
      let isallyear = this.form.allyear ? '1' : '0'
      let westYear = new Date().getFullYear()
      let currentWestYear = String(westYear)
      this.form.startYear = currentWestYear     
      if(isallyear === '1'){this.form.startYear = '2019' }
      if(isallyear === '1'){this.form.startMonth = '12'} else {this.form.startMonth = '01'}
    },
    initMonthOpt() {
      for(var i=1; i<13; i++) {
        let selectItem = {
          value: String(i).length == 1 ? '0' + String(i) : String(i),
          text: `${i}月`
        }
        this.monthOpt.push(selectItem)
      }
      let currentM = this.currentMonth
      if(currentM.length == 1) {
        currentM = '0' + currentM
      }
      let isallyear = this.form.allyear ? '1' : '0'
      if(isallyear === '1'){this.form.startMonth = '12'} else {this.form.startMonth = '01'}
      this.form.endMonth = currentM
    },
    checkRole(){
      let divNo = this.$store.state.userInfo.divNo;
      let mktDeptNo = this.$store.state.userInfo.mktDeptNo;
      let position = this.$store.state.userInfo.position;
      let roleId = this.$store.state.userInfo.roleId;
      let functionId = this.$store.state.userInfo.functionId;
      let roles = this.$store.state.userInfo.roles;
      let re = /^[0-9\s]*$/;
      //console.log("===== function checkRole ===== "+ " id:" + this.$store.state.userInfo.id + " divNo:" + divNo + " mktDeptNo:" + mktDeptNo + " position:" + position + " roleId:" + roleId + " functionId:" + functionId)
      //可以進入頁面的使用者:業務企劃科、業務部的協理、數位支援科、推展企劃科、區部專員、維護單位(通路支援科)、區部協理、通訊處經理、經理授權者
      if( divNo == '0500100' || (divNo == '0500000' && position == '18') || divNo == '9N00200' ||
          roles.hasOwnProperty('RLMX001') ||
          roles.hasOwnProperty('RLMX003') ||
          divNo.slice(0, 2) == '9A' || divNo.slice(0, 2) == '9C' ||
          ( divNo == mktDeptNo && !re.test(divNo.slice(0, 1)) ) ||
          roleId == 'MAINTENANCE_UNIT' ||
          roleId == 'SALES_MANAGER_01' ||
          roleId == 'SALES_MANAGER_02' ||
          ( roleId == 'SALES_MANAGER_06' && functionId && functionId.includes('3') ) ){
        this.rolePermission = true
        return true
      }

      this.rolePermission = false
      return false
    },
    initTransferTab4(){
      this.initMonthOpt()
      this.initYearOpt()
    },
    f_int(s) {    
    if(!s){
        return 0;
    }
    else if(isNaN(s)){
        return 0;
    }
    else{
        return s;
    }   
    },
    downloadData() {
      if (this.isLoading) return false; //防止連點麵包屑  
      var target = '';
      if (this.breadCrumbs.length == 0) {
        return false;
      } else {
        target = this.breadCrumbs[this.breadCrumbs.length - 1].target;
      }

      let report = {};
      report.startDate = this.form.startYear + this.form.startMonth;
      report.endDate = this.form.endYear + this.form.endMonth;
      // lev2因為專展合併，因此讀取全部
      report.ceadcd = target === "lev2" ? "null" : this.breadCrumbs[this.breadCrumbs.length - 1].ceadcd;
      report.monthChk = this.currentMonthChk ? "Y" : "N";

      if (this.dataCheck()) {
        this.isLoading = true;
        dowlnloadMandatoryAllocationSummary(
          this.$store.state.userInfo.id,
          target,
          this.form.no_estrange || false,
          this.form.intime || false,
          report
        ).then(result => {
          if (result.type == "application/json") {
            //  json 為檔案下載失敗
            //  把回傳的 blob 轉為 文字檔後再用 json parse
            let reader = new FileReader();
            reader.onload = function() {
              let unicodeJsonA = JSON.parse(reader.result);
              if (unicodeJsonA.header.message) {
                vm.setToastMsg(unicodeJsonA.header.message);
              } else {
                vm.setToastMsg("伺服器連線異常");
              }
            };
            reader.readAsText(result);
          } else {
            //  成功取得檔案  進行下載
            var fileName;
            let fName='';
            let title='';
            switch(target) {
              case 'lev1':
                fileName = '強制調撥總表-全部.xlsx';
                break;
              case 'lev2':
              case 'lev3':
                fName = this.breadCrumbs[this.breadCrumbs.length - 1].name;
                if (fName == "CEDVNM_1") {
                  title = '專招'
                } else if (fName == "CEDVNM_2") {
                  title = '展業'
                } else {
                  title = fName;
                }
                fileName = `強制調撥總表-${title}-${new Date().getTime()}.xlsx`;
                break;
              default:
                fileName = '強制調撥總表.xlsx';
            }

            saveAs(result, fileName);
          }

          this.isLoading = false;
        });
      }
    },
    chooseCeadcd(val) {
      this.panelClose('ceadcdChooseModalOpen');
      this.downloadData2(val);
    },
    downloadData2(val){//for 下載轄下資料
      var target2;
      if(val == '2'){
        target2 = 'lev2';        
      }else if(val =='3'){
        target2 = 'lev3';
      }
        let report = {};
        report.startDate = this.form.startYear + this.form.startMonth;
        report.endDate = this.form.endYear + this.form.endMonth;
        report.ceadcd = 'null';
        report.monthChk = this.currentMonthChk ? "Y" : "N";
        
      if (this.dataCheck()) {//檢查日期正確性
        this.isLoading = true;
        dowlnloadMandatoryAllocationSummary(
          this.$store.state.userInfo.id,
          target2,
          this.form.no_estrange || false,
          this.form.intime || false,
          report
        ).then(result => {
          if (result.type == "application/json") {
            //  json 為檔案下載失敗
            //  把回傳的 blob 轉為 文字檔後再用 json parse
            let reader = new FileReader();
            reader.onload = function() {
              let unicodeJsonA = JSON.parse(reader.result);
              if (unicodeJsonA.header.message) {
                vm.setToastMsg(unicodeJsonA.header.message);
              } else {
                vm.setToastMsg("伺服器連線異常");
              }
            };
            reader.readAsText(result);
          } else {
            //  成功取得檔案  進行下載
            var fileName;
            if(val == '2'){
              fileName = '區部排名總表.xlsx';
            }else if(val =='3'){
              fileName = '區部轄下通訊處排名總表.xlsx';
            }

            saveAs(result, fileName);
          }

          this.isLoading = false;
        });
      }
    }
  },
  beforeMount () {
    if(!this.checkRole()){
        this.$toast.info({ title: '無該畫面權限' })
        return
    }
    this.initTransferTab4()
  },
  mounted () {
    // 以流水編號查詢企劃單位連絡方式
    getContactInfoBySerNo(this.$store.state.userInfo.id, '11').then(result => {
      if(result && result.header.status == '200' && result.body){
          this.contactInfo  = result.body.lists[0];
      }
    })
  }
}
</script>
<style scoped>
.cus-p{
  margin: 0 0 5px 0;
}
</style>
